module.exports = __webpack_public_path__ + "static/img/role.0d642d7.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/role3/tysdags/role.png
// module id = n5Y6
// module chunks = 7